'use client';

import { useTranslation } from '@/app/i18n/client';
import AppContext from '@/components/AppContext';
import Copyright from '@/components/Copyright';
import LocaleSwitcher from '@/components/LocaleSwitcher';
import Logo from '@/components/Logo';
import ThemeSwitcher from '@/components/ThemeSwitcher';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';

export default function Home() {
  const app = useContext(AppContext);
  const { t } = useTranslation(app.i18n.lng);

  return true ? (
    <>
      <AppBar
        component="nav"
        position="sticky"
        elevation={0}
        // elevation={scrollTrigger ? 4 : 0}
      >
        <Container maxWidth="md">
          <Toolbar disableGutters>
            <Link href="/">
              <Logo height={98} margin={'0.5rem'} />
            </Link>

            <Box sx={{ flexGrow: 1, display: 'flex' }}></Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                flexGrow: 0,
                flexWrap: 'nowrap',
              }}
            >
              <LocaleSwitcher size="small" sx={{ mr: 1 }} />
              <ThemeSwitcher menu size="small" />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'center',
            minHeight: '100vh',
          }}
        >
          <Box
            sx={{
              mt: 'auto',
            }}
          >
            <Box sx={{ mt: 2, mb: 6 }}>
              <Copyright />
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  ) : (
    <Container maxWidth="md">
      <Box
        sx={{
          my: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          <Logo margin="12" />
        </Typography>
      </Box>
      <Box
        sx={{
          my: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'stretch',
        }}
      >
        <Typography variant="subtitle1" gutterBottom component={'p'}>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Error,
          dolores adipisci! Facilis dolore, eligendi fugiat delectus minima
          minus nesciunt deleniti eius, velit amet aliquid at voluptas enim.
          Quod, nulla nemo?
        </Typography>
        <Typography variant="body1">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. In animi
          nemo dolorum at nisi delectus ex corrupti commodi, cupiditate cumque
          sed harum nostrum repellat voluptatibus expedita porro quos facere
          similique?
        </Typography>
        <Typography variant="body1">
          Formularz dostępny jest przez całą dobę.
        </Typography>

        <Copyright />
      </Box>
    </Container>
  );
}
